var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66634 27.0001H6.99967V33.8017L15.5013 27.0001H23.6663C25.5047 27.0001 26.9997 25.5051 26.9997 23.6667V10.3334C26.9997 8.49506 25.5047 7.00006 23.6663 7.00006H3.66634C1.82801 7.00006 0.333008 8.49506 0.333008 10.3334V23.6667C0.333008 25.5051 1.82801 27.0001 3.66634 27.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 0.333435H10.3333C8.495 0.333435 7 1.82843 7 3.66677H27C28.8383 3.66677 30.3333 5.16177 30.3333 7.0001V20.3334C32.1717 20.3334 33.6667 18.8384 33.6667 17.0001V3.66677C33.6667 1.82843 32.1717 0.333435 30.3333 0.333435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.0098f928.svg";
export { ForwardRef as ReactComponent };